import { Stack } from "@mui/material";
import type { FC } from "react";
import {
	ClientPropertyCategoryEnum,
	type ClientPropertyLandDetailResponseDTO,
	ClientPropertyOwnershipEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DetailRow } from "web_myplann/Portfolio/Components/Redesign/Detail/DetailRow";
import { PropertyPurchaseDetails } from "web_myplann/Portfolio/Components/Redesign/Detail/Sections/Property/PropertyPurchaseDetails";
import { formatEnumLabel } from "web_myplann/Portfolio/Helpers/formatEnumLabel";
import { unitFormatter } from "web_myplann/Shared/Utils/numberFormatters";
import { UNITS } from "web_myplann/Shared/Utils/units";

const PageResources = Resources.PortfolioDetail;

type Props = {
	data: ClientPropertyLandDetailResponseDTO;
	currencySign: string;
};

export const LandRedesign: FC<Props> = ({ data }) => {
	const { t } = useResource();

	const ownership = formatEnumLabel(
		data.ownership,
		ClientPropertyOwnershipEnum.None,
		PageResources.Property.OwnershipValue,
		t,
	);

	const landType = formatEnumLabel(
		data.propertyCategory,
		ClientPropertyCategoryEnum.None,
		PageResources.Property.LandTypeEnum,
		t,
	);

	return (
		<>
			<Stack bgcolor="background.paper">
				<DetailRow
					label={t(PageResources.Property.LandType)}
					value={landType}
				/>
				<DetailRow
					label={t(PageResources.Property.LandArea)}
					value={unitFormatter(data.landSize, UNITS.squareMeter)}
				/>
				<DetailRow
					label={t(PageResources.Property.ParcelNumber)}
					value={data.parcelNumber}
				/>
				<DetailRow
					label={t(PageResources.Property.Ownership)}
					value={ownership}
				/>
			</Stack>

			<PropertyPurchaseDetails
				purchaseDate={data.purchaseDate}
				description={data.description}
				lastValuationDate={data.estimatedPriceAt}
			/>
		</>
	);
};
